import store from '../store';

class iframeServe {
  constructor(iframeId, state, type, clientIds) {
    this.iframeId = iframeId;
    this.init(state, type, clientIds);
  }
  init(state, type, clientIds) {
    var iframe = document.getElementById(this.iframeId);
    if (!iframe) {
      console.log('开始创建iframe');
      var doc = window.document;
      const iframe = doc.createElement('iframe');
      iframe.src = 'https://free.yunqingsmart.com';
      iframe.id = 'iframes';
      iframe.style.display = 'none';
      doc.body.appendChild(iframe);
      this.postMessageIframe(state, type, clientIds);
    } else {
      this.postMessageIframe(state, type, clientIds);
    }
  }
  postMessageIframe(state, type = 'setCook', clientIds) {
    console.log('进入19：---');
    var iframe = document.getElementById(this.iframeId);
    console.log('进入21：---');
    console.log(iframe);
    if (iframe) {
      iframe.onload = () => {
        console.log('获取缓存token:' + sessionStorage.getItem('access_token'));
        console.log(type);
        console.log(clientIds);
        if (type == 'setCook') {
          iframe.contentWindow.postMessage(
            {
              type: 'setCook',
              client_uid: sessionStorage.getItem('client_uid'),
              data: sessionStorage.getItem('access_token'),
              uri: sessionStorage.getItem('uri')
            },
            'https://free.yunqingsmart.com'
          );
          this.getMessageIframe(state);
        }
        if (type == 'removeCook') {
          console.log('退出去清除token');
          iframe.contentWindow.postMessage(
            {
              type: type,
              client_uid: clientIds
            },
            'https://free.yunqingsmart.com'
          );
          this.getMessageIframe();
        }
      };
      console.log('57获取缓存token:' + sessionStorage.getItem('access_token'));
      if (type == 'setCook') {
        iframe.contentWindow.postMessage(
          {
            type: 'setCook',
            client_uid: sessionStorage.getItem('client_uid'),
            data: sessionStorage.getItem('access_token'),
            uri: sessionStorage.getItem('uri')
          },
          'https://free.yunqingsmart.com'
        );
        this.getMessageIframe(state);
      }
      if (type == 'removeCook') {
        console.log('退出去清除token');
        iframe.contentWindow.postMessage(
          {
            type: type,
            client_uid: clientIds
          },
          'https://free.yunqingsmart.com'
        );
        this.getMessageIframe();
      }
    }
  }
  getMessageIframe(state) {
    window.addEventListener('message', event => {
      // 严格校验来源，防止恶意网站伪造消息
      if (event.origin !== 'https://free.yunqingsmart.com') return;
      console.log(state);
      console.log('准备跳转');
      var res = JSON.parse(event.data);
      if (state) {
        // location.href = state.uri;
        if (res.type == 'setMsg') {
          if (res.data) {
            store.commit('setLoading', false);
            location.href = JSON.parse(res.data).uri;
          }
        }
      }
      if (res.type == 'removeCook') {
        // 退出登录
        console.log('移除removeCook');
        console.log(res);
        if (res.data && res.msg == 'Remove Ok') {
          sessionStorage.removeItem(JSON.parse(res.data).client_uid);
        } else {
          console.log('error');
        }
      }
    });
  }
}

export default iframeServe;
